import * as util from "./util.js";
import * as cconst from "./const.js";
import * as sinterface from "./interface.js";
import type { AppState } from "./app.js";
import type { UI } from "./ui.js";
const Class = util.Class;
const MaskGenerator = sinterface.MaskGenerator;

class RemovalGenerator extends MaskGenerator {
  constructor(appstate?: AppState) {
    super(appstate);
  }

  step(custom_steps?: number) {}

  reset(dimen: number, appstate: AppState, mask_image: ImageData) {
    super.reset(dimen, appstate, mask_image);
  }

  draw(g: CanvasRenderingContext2D) {
    super.draw(g);
  }

  //optional
  next_level() {}

  regen_spatial() {
    return super.regen_spatial();
  }
}
util.registerClass(RemovalGenerator);

export { RemovalGenerator };
